import { createContext, useContext, useState } from 'react';
import useMaintenanceGroups from '../hooks/useMaintenanceGroups';

const MaintenanceDeviceContext = createContext();

// Have to pass in value because the parent component also needs access to the same
//    instance of the hook.
export const MaintenanceDeviceProvider = ({ children }) => {
  const maintenanceGroups = useMaintenanceGroups();
  const [selectedDevice, setSelectedDevice] = useState(null);

  return (
    <MaintenanceDeviceContext.Provider
      value={{ maintenanceGroups, selectedDevice, setSelectedDevice }}
    >
      {children}
    </MaintenanceDeviceContext.Provider>
  );
};

export const useMaintenanceDeviceContext = () => {
  const context = useContext(MaintenanceDeviceContext);
  if (context === undefined) {
    throw new Error('useIntegrationContext must be used within a IntegrationProvider.');
  }

  return context;
};
